"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanTrial = void 0;

var getCanTrial = function getCanTrial(state, upgradeProduct) {
  if (!state.trialState) return false;
  var trialNames = state.trialState.map(function (trial) {
    return trial.name;
  });
  return trialNames.indexOf(upgradeProduct) !== -1;
};

exports.getCanTrial = getCanTrial;